module.exports = __webpack_public_path__ + "static/media/crunchyroll.bc220bcc.png";